window.theme = window.theme || {},
window.Shopify = window.Shopify || {},
theme.config = {
    hasSessionStorage: !0,
    hasLocalStorage: !0,
    mqlSmall: !1,
    mediaQuerySmall: "screen and (max-width: 767px)",
    motionReduced: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    isTouch: "ontouchstart"in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
    rtl: document.documentElement.getAttribute("dir") === "rtl"
},
theme.supportsPassive = !1,
theme.initWhenVisible = function() {
    class ScriptLoader {
        constructor(callback, delay=5e3) {
            this.callback = callback,
            this.triggered = !1,
            this.timeoutId = null,
            this.interactionEvents = ["click", "mousemove", "keydown", "touchstart", "touchmove", "wheel"],
            this.handleInteraction = this.handleInteraction.bind(this),
            this.interactionEvents.forEach(eventType => {
                window.addEventListener(eventType, this.handleInteraction, {
                    passive: !0
                })
            }
            ),
            this.timeoutId = setTimeout( () => {
                this.triggered || this.handleInteraction({
                    type: "timeout"
                })
            }
            , delay)

        }
        handleInteraction(event) {
            this.triggered || (this.triggered = !0,
            this.callback(event),
            this.cleanup())
        }
        cleanup() {
            this.interactionEvents.forEach(eventType => {
                window.removeEventListener(eventType, this.handleInteraction, {
                    passive: !0
                })
            }
            ),
            clearTimeout(this.timeoutId),
            this.timeoutId = null,
            this.callback = null
        }
    }
    return ScriptLoader
}(),
new theme.initWhenVisible( () => {
    document.body.removeAttribute("data-page-rendering")
}
);


class MarqueeElement extends HTMLElement {
    constructor() {
        super(),
        !theme.config.motionReduced && (!theme.config.isTouch || Shopify.designMode ? Motion.inView(this, this.init.bind(this), {
            margin: "200px 0px 200px 0px"
        }) : new theme.initWhenVisible(this.init.bind(this)))
    }
    get childElement() {
        return this.firstElementChild
    }
    get speed() {
        return this.hasAttribute("data-speed") ? parseInt(this.getAttribute("data-speed")) : 16
    }
    get maximum() {
        return this.hasAttribute("data-maximum") ? parseInt(this.getAttribute("data-maximum")) : Math.ceil(this.parentWidth / this.childElementWidth) + 2
    }
    get direction() {
        return this.hasAttribute("data-direction") ? this.getAttribute("data-direction") : "left"
    }
    get parallax() {
        return !theme.config.isTouch && this.hasAttribute("data-parallax") ? parseFloat(this.getAttribute("data-parallax")) : !1
    }
    get parentWidth() {
        return this.getWidth(this)
    }
    get childElementWidth() {
        return this.getWidth(this.childElement)
    }
    init() {
        if (!this.initialized) {
            if (this.initialized = !0,
            this.childElementCount === 1) {
                this.childElement.classList.add("animated");
                const maximum = this.maximum;
                for (let index = 0; index < maximum; index++)
                    this.clone = this.childElement.cloneNode(!0),
                    this.clone.setAttribute("aria-hidden", !0),
                    this.appendChild(this.clone),
                    this.clone.querySelectorAll(".media").forEach(media => media.classList.remove("loading"));
                this.style.setProperty("--duration", `${(33 - this.speed) * Math.min(2.5, Math.ceil(this.childElementWidth / this.parentWidth))}s`)
            }
            if (this.parallax) {
                let translate = this.parallax * 100 / (1 + this.parallax);
                this.direction === "right" && (translate = translate * -1),
                theme.config.rtl && (translate = translate * -1),
                Motion.scroll(Motion.animate(this, {
                    transform: [`translateX(${translate}%)`, "translateX(0)"]
                }, {
                    easing: "linear"
                }), {
                    target: this,
                    offset: ["start end", "end start"]
                })
            } else
                new IntersectionObserver( (entries, _observer) => {
                    entries.forEach(entry => {
                        entry.isIntersecting ? this.classList.remove("paused") : this.classList.add("paused")
                    }
                    )
                }
                ,{
                    rootMargin: "0px 0px 50px 0px"
                }).observe(this)
        }
    }
    getWidth(element) {
        const rect = element.getBoundingClientRect();
        return rect.right - rect.left
    }
}
customElements.define("marquee-element", MarqueeElement);